export const traderNameErrorText = 'Начинается с A-Z, 3–50 символов. Разрешены: буквы, цифры, _, :';
export const traderNameRegex = /^[A-Z][A-Za-z0-9_:]{2,49}$/;
